import { useState } from 'react';

import { DeleteOutline } from '@mui/icons-material';
import { IconButton } from '@mui/material';

import { ConfirmModal } from 'components/modal';
import { useDeleteConfiguracao } from 'pages/financeiro/dre/configuracao/hooks';
import { DreConfiguracao } from 'pages/financeiro/dre/configuracao/types';

export function DreConfigConfiguracoesDelete({ configuracao }: { configuracao: DreConfiguracao }) {
    const [openConfirmModal, setOpenConfirmModal] = useState(false);
    const { handleDelete } = useDeleteConfiguracao();

    return (
        <>
            <ConfirmModal
                open={openConfirmModal}
                setOpen={setOpenConfirmModal}
                confirm={() => handleDelete(configuracao.idDreMercadologicaConfiguracao)}
            />

            <IconButton sx={{ width: 20, height: 20, color: configuracao.color.text }} onClick={() => setOpenConfirmModal(true)}>
                <DeleteOutline />
            </IconButton>
        </>
    );
}
